// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps, GridItemStyle } from "@insite/mobius/GridItem";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import XngZone from "@west/App/Components/Common/XngZone";
import { GridContainerProps } from "@west/MobiusOverrides/GridContainer/GridContainer";
import React, { FC } from "react";
import { css } from "styled-components";

const enum fields {
    layoutDirection = "layoutDirection",
}

interface OwnProps extends WidgetProps {
    [fields.layoutDirection]: "leftToRight" | "rightToLeft";
}

type Props = OwnProps;

export interface BannersLayoutStyles {
    gridContainer?: GridContainerProps;
    slideShowGridItem?: GridItemProps;
    bannersGridItem?: GridItemProps;
    imageContainer?: InjectableCss;
}

export const bannersLayoutStyles: BannersLayoutStyles = {};

const styles = bannersLayoutStyles;
const BannersLayout: FC<Props> = ({ fields, id }) => {
    const customOffsetCss = css`
        ${styles.gridContainer?.offsetCss}
        ${fields.layoutDirection === "rightToLeft" &&
        css`
            &&& {
                flex-direction: row-reverse;
                flex-wrap: wrap-reverse;
            }
        `}
    `;

    return (
        <GridContainer {...styles.gridContainer} data-test-selector="BannersLayout" offsetCss={customOffsetCss}>
            <GridItem {...styles.slideShowGridItem}>
                <XngZone contentId={id} zoneName="Content00" hint="SlideShow" />
            </GridItem>
            <GridItem {...styles.bannersGridItem}>
                <StyledWrapper {...styles.imageContainer}>
                    <XngZone contentId={id} zoneName="Content01" hint="Banner01" />
                </StyledWrapper>
                <StyledWrapper {...styles.imageContainer}>
                    <XngZone contentId={id} zoneName="Content02" hint="Banner02" />
                </StyledWrapper>
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: BannersLayout,
    definition: {
        group: "Layout" as any,
        displayName: "Banners Layout",
        fieldDefinitions: [
            {
                name: fields.layoutDirection,
                displayName: "Layout Direction",
                editorTemplate: "DropDownField",
                options: [
                    { displayName: "Left to Right", value: "leftToRight" },
                    { displayName: "Right To Left", value: "rightToLeft" },
                ],
                defaultValue: "leftToRight",
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
